import Typography from "@material-ui/core/Typography"
import React, { useEffect, useRef } from "react"

import { GetMyCourse_myStudentCourse_course_lessons } from "../../queries/types/GetMyCourse"
import styled from "styled-components"
import { editorCSS } from "../../../helpers/constants/editorCSS"

interface Props {
  lesson: GetMyCourse_myStudentCourse_course_lessons
  lessonNumber: number
}

const LessonContent = ({
  lesson: { title, content, attachment },
  lessonNumber,
}: Props) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const titlePrepend = lessonNumber === 0 ? "" : `Lesson ${lessonNumber}: `

  useEffect(() => {
    if (content) {
      let processedContent = content
      if (attachment && processedContent.includes("[[video]]")) {
        // Create a styled div wrapper for the video
        const videoWithWrapper = `<div style='max-width: 100%;
        max-height: 100%;
        height: auto;
        aspect-ratio: 16 / 9;'>
        ${attachment}
      </div>`

        // Replace [[video]] placeholder with the wrapped video
        processedContent = processedContent.replace(
          /\[\[video]]/g,
          videoWithWrapper
        )
      }

      // Create a temporary container to parse the HTML
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = processedContent

      // Find all <script> tags
      const scripts = Array.from(tempDiv.querySelectorAll("script"))

      // Append scripts to the <head> if they don't already exist
      scripts.forEach((script) => {
        if (script.src) {
          // Check if a script with this src already exists
          const scriptExists = Array.from(
            document.head.querySelectorAll("script")
          ).some((existingScript) => existingScript.src === script.src)

          if (!scriptExists) {
            const newScript = document.createElement("script")
            newScript.type = script.type || "text/javascript"
            newScript.src = script.src
            newScript.async = true
            document.head.appendChild(newScript)
          }
        } else {
          // For inline scripts, check based on content
          const scriptContent = script.textContent || ""

          // Check if an identical inline script already exists
          const scriptExists = Array.from(
            document.head.querySelectorAll("script")
          ).some(
            (existingScript) =>
              !existingScript.src &&
              existingScript.textContent === scriptContent
          )

          if (!scriptExists) {
            const newScript = document.createElement("script")
            newScript.type = script.type || "text/javascript"
            newScript.textContent = scriptContent
            document.head.appendChild(newScript)
          }
        }
      })

      // Remove the scripts from the tempDiv to avoid duplicate execution
      scripts.forEach((script) => script.remove())

      // Set the remaining HTML (minus the scripts) into the contentRef
      if (contentRef.current) {
        contentRef.current.innerHTML = tempDiv.innerHTML
      }
    }
  }, [content, attachment])

  return (
    <ContentWrapper>
      <Typography variant="h6">{titlePrepend + title}</Typography>
      <StyledDiv ref={contentRef} />
    </ContentWrapper>
  )
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  //max-height: 70vh;
  //overflow-y: auto;
`

const StyledDiv = styled.div`
  ${editorCSS};
`

export default LessonContent
